import React from "react";
import { NavLink } from "react-router-dom";

const InsuranceValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Insurance Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Insurance valuation are commonly required for the replacement value of
          the building ( improvement excluding land ) in case of damage due to (
          accident, fire, floods or weather etc. ). Primus Agent
          Services have over ten (10) years experience in providing insurance
          valuations to major strata bodies and insurance companies.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default InsuranceValuationTab;
